import useU2000AxiosAuthenticated from "../../axios/U2000UseAxiosAuthenticated";
import { useU2000AuthContext } from "../../context/auth/U2000UseAuthContext";

const LOGICALUNIT_URL = "U2001";
const SELECTORGANIZATION_URL = LOGICALUNIT_URL + "/selectOrganization";

type MenuType = any; // Remplacer par le type réel si connu
type SelectOrganizationFn = (uuid: string, menu: MenuType) => Promise<any>; // Remplacer any par le type réel si connu

const useU2000SelectOrganization = (): SelectOrganizationFn => {
  const { login } = useU2000AuthContext();
  const u2000AxiosAuthenticated = useU2000AxiosAuthenticated();

  const doSelectOrganization: SelectOrganizationFn = async (uuid, menu) => {
    try {
      const response = await u2000AxiosAuthenticated.post(SELECTORGANIZATION_URL, JSON.stringify({ uuid }), {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return login(response.data, menu);
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
  return doSelectOrganization;
};

export default useU2000SelectOrganization;
